import { memo } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

// Small, non-blocking loading indicator for lazy-loaded dialogs that are still fetching their
// chunk -- unlike PageLoader, this doesn't cover the whole viewport, since opening a dialog for
// the first time shouldn't block interaction with the rest of the page for however briefly its
// (small) chunk takes to load.
const DialogLoader = () => (
  <Box sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: (theme) => theme.zIndex.modal + 1 }}>
    <CircularProgress size={32} />
  </Box>
);

export default memo(DialogLoader);
